import Tracker from "../prop-trackers/tracker.js";
import { CombinerForEach, ValueCombiner } from "./combiner-for-each.js";
import DictTracker from "../prop-trackers/dict-tracker.js";

class Combiner extends Tracker {
    constructor(createValueCombiner, userdata) {
        super();

        this._valueCombinerKey = new WeakMap();

        const wrapCreateValCombiner = (key) => {
            const valueCombiner = createValueCombiner(key);
            this._valueCombinerKey.set(valueCombiner, key);
            return valueCombiner;
        };

        this._combinerForEach = new CombinerForEach(wrapCreateValCombiner);
        this._output = new DictTracker(userdata);

        const needsUpdate = () => this.protected_needsUpdate();
        this._combinerForEach.listenNeedsUpdate(needsUpdate);
    }

    setSource(sourceKey, sourceTracker) {
        this._combinerForEach.setSource(sourceKey, sourceTracker);
    }

    deleteSource(sourceKey, sourceTracker) {
        this._combinerForEach.deleteSource(sourceKey);
    }

    protected_startUpdate() {
        this._combinerForEach.update(({ trackers }) => {
            for (const valueCombiner of trackers) {
                const key = this._valueCombinerKey.get(valueCombiner);

                valueCombiner.update(({ prop: { newExists, newValue } }) => {
                    if (newExists) {
                        this._output.setValue(key, newValue);
                    } else {
                        this._output.deleteValue(key);
                    }
                });
            }
        });

        return this._output.startUpdate();
    }

    protected_finishUpdate() {
        this._output.finishUpdate();
    }
}

Combiner.ValueCombiner = ValueCombiner;

export default Combiner;
export { Combiner, ValueCombiner };
